import React from 'react';

export const Atm = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="17"
      fill="none"
      viewBox="0 0 23 17"
    >
      <path
        stroke="#00B3BF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M16.597 6.3h3.79a.875.875 0 00.875-.875v-3.5a.875.875 0 00-.875-.875H2.012a.875.875 0 00-.875.875v3.5c0 .483.392.875.875.875H5.81"
      ></path>
      <path
        stroke="#00B3BF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M17.762 12.857a.437.437 0 01-.437.443H5.081a.437.437 0 01-.437-.443c.047-3.81.716-5.507 2.181-9.182h8.75c1.473 3.675 2.141 5.373 2.188 9.182z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#00B3BF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.875"
        d="M5.516 15.05h11.375M4.203 3.675h14.875m-7.874 2.187v-.875"
      ></path>
    </svg>
  );
};
